import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RootScopeService } from '../../services/root-scope.service';
import * as Constants from '../../models/Constants';
@Component({
  selector: 'app-ssofailure',
  templateUrl: './ssofailure.component.html',
  styleUrls: ['./ssofailure.component.scss']
})
export class SsofailureComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private rootScope: RootScopeService) { }

  ngOnInit(): void {
    this.rootScope.ssoError=Constants.errorObj.ssoError;
    this.rootScope.errorMsg=Constants.errorObj.ssoError;//showing error message when sso fails
    this.router.navigate(['/login']);

  }
}


